module.exports = ".upload-button {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    min-width: 100%;\r\n    min-height: 100%;\r\n    font-size: 100px;\r\n    text-align: right;\r\n    filter: alpha(opacity=0);\r\n    opacity: 0;\r\n    outline: none;\r\n    background: white;\r\n    cursor: inherit;\r\n    display: block;\r\n}\r\n\r\n.btn-file {\r\n    overflow: hidden;\r\n    position: relative;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/files/edit-file/edit-file.component.css
// module id = ./src/app/files/edit-file/edit-file.component.css
// module chunks = main